/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";
import { GraduationCap, Lock, Glasses, Play, CheckCircle2, BookOpen, Loader2 } from "lucide-react";

const TYPE = { vr: { label: "Réalité virtuelle", Icon: Glasses }, simulation: { label: "Mise en situation", Icon: Play }, cours: { label: "Cours", Icon: BookOpen } };

export default function TrainingPage() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const load = () => api.get("/training/modules").then(({ data }) => setData(data)).catch(() => null);
  useEffect(() => { load(); }, []);

  const advance = async (m) => {
    try { await api.post("/training/progress", { module_id: m.id, etapes_faites: Math.min(m.etapes, m.etapes_faites + 1) }); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  if (!data) return <div className="py-20 grid place-items-center"><Loader2 className="animate-spin text-[#2BA3A0]" /></div>;
  const done = data.modules.filter((m) => m.termine).length;

  return (
    <div className="bc-in flex flex-col gap-5" data-testid="pro-training">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="text-[11px] uppercase tracking-wider text-[#0A1426]/60 font-bold">Formation des praticiens</div>
          <h1 className="font-[Fraunces] text-3xl font-bold text-[#0A1426]">Protocole AVC</h1>
        </div>
        <div className="text-[12px] bg-white border border-[#E4E0D5] rounded-full px-3 py-1.5 text-[#0A1426]">{done}/{data.modules.length} modules terminés</div>
      </div>

      {!data.debloque && (
        <div data-testid="training-locked" className="rounded-3xl bg-[#0A1426] text-white p-5 flex flex-col sm:flex-row sm:items-center gap-4">
          <Lock size={28} className="text-[#D4AF5A]" />
          <div className="flex-1">
            <div className="font-[Fraunces] text-xl font-bold">Module verrouillé</div>
            <p className="text-[13px] text-white/80">Inclus dans le forfait Clinique, ou achetez le module Formation à l'unité.</p>
          </div>
          <Button data-testid="training-unlock-btn" onClick={() => navigate("/pro/subscription")} className="h-11 rounded-full bg-[#D4AF5A] text-[#0A1426] font-bold">Débloquer</Button>
        </div>
      )}

      <div className="grid md:grid-cols-2 gap-4">
        {data.modules.map((m) => { const T = TYPE[m.type]; const pct = Math.round(m.etapes_faites / m.etapes * 100); return (
          <div key={m.id} data-testid={`module-${m.id}`} className={`bg-white rounded-3xl border border-[#E4E0D5] p-5 flex flex-col gap-3 ${!data.debloque ? "opacity-70" : ""}`}>
            <div className="flex items-start gap-3">
              <div className="w-12 h-12 rounded-2xl bg-[#F5F3EE] grid place-items-center text-[#2BA3A0]"><T.Icon size={24} /></div>
              <div className="flex-1">
                <div className="text-[10px] uppercase tracking-wider text-[#0A1426]/60 font-bold">{T.label} · {m.duree}</div>
                <div className="font-[Fraunces] text-lg font-bold text-[#0A1426] leading-tight">{m.titre}</div>
              </div>
              {m.termine && <CheckCircle2 className="text-[#5CB85C]" />}
            </div>
            <p className="text-[13px] text-[#0A1426]/75">{m.description}</p>
            <div>
              <div className="flex justify-between text-[11px] text-[#0A1426]/60 mb-1"><span>Progression</span><span>{m.etapes_faites}/{m.etapes}</span></div>
              <div className="h-2 bg-[#F5F3EE] rounded-full overflow-hidden"><div className="h-full bg-[#2BA3A0] transition-all" style={{ width: `${pct}%` }} /></div>
            </div>
            <Button data-testid={`module-${m.id}-next`} disabled={!data.debloque || m.termine} onClick={() => advance(m)}
              className="h-11 rounded-full bg-[#2BA3A0] hover:bg-[#0A1426] text-white font-bold disabled:opacity-40">
              <GraduationCap size={16} className="mr-2" /> {m.termine ? "Terminé" : m.etapes_faites ? "Continuer" : "Commencer"}
            </Button>
          </div>
        ); })}
      </div>
    </div>
  );
}
